export class ApiClientError extends Error {
    constructor(details) {
        super(details.message);
        this.details = details;
    }
}
